const STATUS_STYLE_MAP = {
  "Open":      { background: "#FED7AA", color: "#C2410C" },
  "On Hold":   { background: "#FEF08A", color: "#A16207" },
  "Escalated": { background: "#FECACA", color: "#B91C1C" },
  "Closed":    { background: "#BBF7D0", color: "#15803D" },
};

export default function StatusBadge({ status }) {
  const style = STATUS_STYLE_MAP[status] || { background: "#F3F4F6", color: "#374151" };
  return (
    <span
      style={{
        ...style,
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "9999px",
        padding: "2px 10px",
        fontSize: "12px",
        fontWeight: 600,
      }}
    >
      {status || "—"}
    </span>
  );
}
